module.exports = __webpack_public_path__ + "static/media/george-loading-white.c86fcb19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/george-loading-white.svg
// module id = 720
// module chunks = 21